import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const categoryInit = {
  categories: {},
  isLoadingCategories: false,
};

function categoriesReducer( draft, { type, payload } ) {
  switch (type) {
    case "setCategories": {
      let newState = {}
      
      payload.Categories.forEach(cat => newState[cat.id] = cat)
      draft.categories  = newState
      break;
    }
    case "createCategories": {
      payload.Categories.forEach(cat => draft.categories[[cat.id]] = cat)
      break;
    }
    case "setIsLoadingCategories": {
      draft.isLoadingCategories = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [CategoryContext, CategoryDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function CategoryProvider({ init, children }) {
  const [categoryStore, dispatch] = useImmerReducer(categoriesReducer, categoryInit);

  return (
    <CategoryContext.Provider value={init || categoryStore}>
      <CategoryDispatchContext.Provider value={dispatch}>
        {children}
      </CategoryDispatchContext.Provider>
    </CategoryContext.Provider>
  );
}

export function useCategoryStore() {
  return useContext(CategoryContext);
}

export function useCategoryDispatch() {
  return useContext(CategoryDispatchContext);
}